/* ============================================================
   ⚑ 2026-09-05: THIS FILE IS NO LONGER THE FIRST COPY TO RUN. EDIT THE SNIPPET.

   `snippets/int-pair-row-inline.liquid` holds the same code and is rendered INLINE at the
   end of `sections/intention-word-of-intention.liquid`, so the wrapper is built during
   parse instead of at DOMContentLoaded. This file is still loaded and is still a real
   fallback: the inline copy claims `window.__intPairRow` ONLY after `.int-pairrow` is
   actually in the DOM, so whenever the build legitimately does not happen there (one of
   the two sections missing or empty, which is normal on a one-sided print) this file still
   runs at DOMContentLoaded exactly as before.

   WHY IT MOVED. `defer` cannot execute before first paint. Measured on the draft at 400px
   on apparel: intention_photo_art 792 -> 638 and intention_word_of_intention 489 -> 793
   after the page was already laid out.

   ⛔ DO NOT copy the snippet's boot back into here. The snippet calls apply() immediately
   because it runs inline; this file must not, because at its own execution time it is the
   DOMContentLoaded path. They are deliberately different.
   ============================================================ */

/* ============================================================
   assets/int-pair-row.js                    INTENTION — 2026-09-03
   WORD OF INTENTION AND PHOTO ART, SIDE BY SIDE ON DESKTOP.

   Nils: "Would it look better to have PHoto Art image and Word Of Intention
   image next to each other and their descriptions below each. So Word of
   Intention to the left and Photo Art to the right. Then both images could be
   bigger and make that section the same width as The section we create above
   for accordion + replacement."

   ⚑ WHY THIS IS JAVASCRIPT AND THE ACCORDION ROW IS NOT. These are two
   separate top-level Shopify sections — `..._intention_photo_ar` and
   `..._intention_word_of_` — rendered as siblings under #MainContent. Liquid
   cannot wrap two sections in one element; only the DOM can.

   ⚑ WHY THE INNER LAYOUT IS SET WITH INLINE STYLES, NOT A STYLESHEET. Each
   section styles itself through `#ipa-wrap-<section.id>` / `#iwoi-wrap-<id>`,
   an ID selector, and several of those rules already carry !important — for
   example `align-items: stretch !important` above 750px. A linked sheet
   cannot name the id (it is generated per section) and (0,2,0) loses to
   (1,1,0) even with !important on both sides. An inline style set with
   `setProperty(..., 'important')` outranks every rule in every sheet, which
   is the only version of this that is not a specificity race. Everything set
   here is recorded and removed again below 821px.

   ⚑ ORDER: IMAGE ABOVE ITS DESCRIPTION. Photo Art renders .img then .text;
   Word of Intention renders .text then .img when the image sits right. Rather
   than moving nodes, both columns are made flex and the two children are
   given explicit `order` values, so the markup is untouched and the phone,
   which this never runs for, keeps its own arrangement.

   ⚑ NOTHING RUNS OFF THE PRODUCT PAGE. Both sections are used elsewhere.
   ============================================================ */
(function () {
  'use strict';
  if (window.__intPairRow) return;
  window.__intPairRow = true;

  var MQ = '(min-width: 821px)';
  var touched = [];   // [element, property] pairs, so the undo is exact

  function set(el, prop, val) {
    if (!el) return;
    el.style.setProperty(prop, val, 'important');
    touched.push([el, prop]);
  }
  function clearAll() {
    for (var i = 0; i < touched.length; i++) {
      touched[i][0].style.removeProperty(touched[i][1]);
    }
    touched = [];
  }

  function sections() {
    return {
      word: document.querySelector('[id*="__intention_word_of_"]'),
      photo: document.querySelector('[id*="__intention_photo_ar"]')
    };
  }

  /* ⚑ BOTH HALVES OR NEITHER. Most framed prints carry a Photo Art and no Word
     of Intention (and a Word of Intention print is the mirror of that), and the
     empty section still renders as an empty div. Measured on Dancing Cowboy:
     the word section's innerHTML was zero characters, so the row put Photo Art
     in the right column and left the left half blank. A `.wrap` is the
     structural proof that a section actually rendered something — checked
     before the wrapper is built, so a one-sided product keeps the full width
     layout it has always had. */
  function bothPresent(s) {
    return !!(s.word && s.word.querySelector('.wrap') &&
              s.photo && s.photo.querySelector('.wrap'));
  }

  /* Build the wrapper once. Moving the two section nodes is safe: they carry
     no form controls, so the variant machinery is not involved. */
  function build() {
    if (document.querySelector('.int-pairrow')) return document.querySelector('.int-pairrow');
    var s = sections();
    if (!s.word || !s.photo || !s.photo.parentNode) return null;
    if (!bothPresent(s)) return null;

    var row = document.createElement('div');
    row.className = 'int-pairrow';
    s.photo.parentNode.insertBefore(row, s.photo);

    /* the shared headline lives inside the Photo Art section; hoist it so it
       spans both columns instead of sitting on top of the right one */
    var head = s.photo.querySelector('.wrapper .int-accordion-headline');
    if (head && head.parentNode) {
      var headWrap = head.parentNode;
      headWrap.classList.add('int-pairrow__head');
      row.appendChild(headWrap);
    }

    /* ⚑ PHOTO ART FIRST IN THE MARKUP, SECOND ON DESKTOP. The template renders
       Photo Art above Word of Intention and that is the order the phone has
       always shown, so the wrapper preserves it and assets/int-pair-row.css
       swaps them with `order` above 821px only. Appending them the other way
       round would have quietly reversed the phone. The headline already sat at
       the top of the Photo Art section, so hoisting it changes nothing there. */
    row.appendChild(s.photo);
    row.appendChild(s.word);
    return row;
  }

  function stack(sectionEl, imgSel, textSel, imgDisplay) {
    if (!sectionEl) return;
    var wrap = sectionEl.querySelector('.wrap');
    if (!wrap) return;
    /* the row inside each section: one column, not two */
    set(wrap, 'display', 'flex');
    set(wrap, 'flex-direction', 'column');
    set(wrap, 'grid-template-columns', 'none');
    set(wrap, 'align-items', 'stretch');

    /* the section's own centring box stops centring inside a half-width column */
    var box = wrap.parentNode;
    if (box) {
      set(box, 'max-width', 'none');
      set(box, 'margin-inline', '0');
      set(box, 'padding-inline', '0');
    }

    var img = sectionEl.querySelector(imgSel);
    var text = sectionEl.querySelector(textSel);
    [img, text].forEach(function (el) {
      if (!el) return;
      set(el, 'max-width', 'none');
      set(el, 'width', '100%');
      set(el, 'justify-self', 'stretch');
      set(el, 'align-self', 'auto');
      set(el, 'transform', 'none');
      set(el, 'margin', '0');
    });
    /* ⚑ THE WORD PANEL IS A FLEX BOX, THE PHOTO BOX IS NOT. The section's own
       rules set `.img { display: grid !important }` above 750px, which would
       beat the flex centring assets/int-pair-row.css asks for, so the display
       value is written here with the rest. */
    if (img) set(img, 'display', imgDisplay || 'block');
    if (text) set(text, 'display', 'block');

    /* image above its own description, whichever way the section renders them */
    if (img) { set(img, 'order', '1'); set(img, 'margin-bottom', '18px'); }
    if (text) set(text, 'order', '2');

    /* ⚑ THE ARTWORK IS CONTAINED, NOT STRETCHED. Both boxes are equal square
       linen panels now (assets/int-pair-row.css), so a photograph that is not
       square letterboxes on the linen rather than being cropped or forcing
       the panel out of shape. The section's own rules set a width on the
       image, hence the override here rather than in the sheet. */
    var el = sectionEl.querySelector('.ipa-img-el, .iwoi-img-el');
    if (el) {
      set(el, 'width', 'auto');
      set(el, 'height', 'auto');
      set(el, 'max-width', '100%');
      set(el, 'max-height', '100%');
      set(el, 'object-fit', 'contain');
    }
  }

  /* ⚑ equalise() USED TO LIVE HERE and has been removed. It measured the
     Photo Art image and gave the word panel that exact height, which only held
     while the photo happened to be squarish; a wide shot would have produced a
     short pair and a portrait a very tall one. Two square panels with the
     artwork contained do the same job for every image shape, in CSS, with
     nothing to measure and nothing to re-measure on resize. */

  /* ── THE ARTWORK FILLS ITS PANEL, WHATEVER MARGIN THE FILE CARRIES ─────
     Nils: "The Photo Art Should be as big as the Word of Intention
     background." With both panels equal and the artwork contained, the Photo
     Art still read small — and the cause is in the file, not the layout.

     ⚑ MEASURED, NOT GUESSED. Downloaded and inspected the two assets:
         Dancing_In_Colours.001.webp   800 x 640, art occupies 502 x 502
                                       -> 63% of the width is picture,
                                          the rest is transparent margin
         the word artwork              2200 x 537, art fills it
     So the photograph was being drawn at 63% of its own element while the
     signature filled its own. No amount of CSS on the panel can fix that,
     because the margin is inside the image.

     This reads the alpha channel on a 96px scratch canvas, finds the bounding
     box of the actual ink, and scales the element up by exactly the amount
     needed for that ink to reach the panel edge. Same-origin images, so the
     canvas is not tainted; wrapped in try/catch so a future CDN change that
     taints it degrades to no scaling rather than to a blank panel.

     ⚑ AN OPAQUE PHOTOGRAPH GETS scale(1). fw and fh both come out 1, so the
     factor resolves to 1 and nothing happens — this only ever undoes
     transparent padding, it never crops a picture.

     ⚑ CAPPED AT 1.85. Past that a raster from an 800px source is being
     stretched further than it can stay sharp, and a nearly-empty file would
     otherwise blow one glyph up to fill the panel. */
  var MAX_ART_SCALE = 1.85;

  function fitArt(img) {
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    var box = img.getBoundingClientRect();
    if (!box.width || !box.height) return;
    var s = 1;
    try {
      var cw = 96;
      var ch = Math.max(1, Math.round(cw * img.naturalHeight / img.naturalWidth));
      var cv = document.createElement('canvas');
      cv.width = cw; cv.height = ch;
      var ctx = cv.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, cw, ch);
      var d = ctx.getImageData(0, 0, cw, ch).data;
      var minX = cw, minY = ch, maxX = -1, maxY = -1;
      for (var y = 0; y < ch; y++) {
        for (var x = 0; x < cw; x++) {
          if (d[(y * cw + x) * 4 + 3] > 12) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (maxX < 0) return;
      var fw = (maxX - minX + 1) / cw;
      var fh = (maxY - minY + 1) / ch;
      /* the picture as object-fit: contain draws it inside the element box */
      var k = Math.min(box.width / img.naturalWidth, box.height / img.naturalHeight);
      var pw = img.naturalWidth * k, ph = img.naturalHeight * k;
      s = Math.min(box.width / (pw * fw), box.height / (ph * fh));
    } catch (e) { return; }
    if (!isFinite(s) || s <= 1.02) return;
    set(img, 'transform', 'scale(' + Math.min(s, MAX_ART_SCALE).toFixed(3) + ')');
  }

  function fitAll() {
    var s = sections();
    [s.word && s.word.querySelector('.iwoi-img-el'),
     s.photo && s.photo.querySelector('.ipa-img-el')].forEach(function (img) {
      if (!img) return;
      if (img.complete && img.naturalWidth) fitArt(img);
      else img.addEventListener('load', function () { fitArt(img); }, { once: true });
    });
  }

  function apply() {
    var row = build();
    if (!row) return;
    var wide = window.matchMedia(MQ).matches;
    document.body.classList.toggle('int-pairrow-on', wide);
    clearAll();
    if (!wide) return;
    var s = sections();
    stack(s.word, '.img', '.text', 'flex');
    stack(s.photo, '.img', '.text', 'flex');
    fitAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(apply, 150);
  }, false);
})();
